import type { Money } from '@nzyme/money/Money.js';

/**
 * Price quoted in the landing page marketing copy.
 *
 * Placeholder stub: the shared `CONSULTATION_PRICE` was removed with the legacy per-consultation
 * PLN checkout, and the US offering is a Stripe subscription whose pricing lives in the `product`
 * table. Until the landing copy is rewritten for that offering, the marketing sections keep quoting
 * a price from here instead of from a backend constant.
 */
export const LANDING_CONSULTATION_PRICE: Money = [69_00, 'PLN'];
